export enum ColorEnum {
  Orange = '#DE542C',
  Background = '#EEF0ED'
}
